import React, { Component } from 'react';
import { Container } from 'reactstrap';
import styles from './CoverageDocs.module.css';
import USAMap from '../../../components/Vendor/Apple/FileInfo/usaMap';
import data from '../../../components/Vendor/Apple/FileInfo/usaMap/data/usa-states-dimensions.json';
import DocumentTitle from 'react-document-title';
import { DropDownAutoComplete } from '../../../components/inputs/DropDownAutoComplete';
import classNames from 'classnames';
import { dataLayerPush } from '../../../helpers';
import ExNY_CoverageDoc from '../../../assets/Documents/CoverageDocuments/ExNY.pdf';
import AK_CoverageDoc from '../../../assets/Documents/CoverageDocuments/AK.pdf';
import AZ_CoverageDoc from '../../../assets/Documents/CoverageDocuments/AZ.pdf';
import AR_CoverageDoc from '../../../assets/Documents/CoverageDocuments/AR.pdf';
import CO_CoverageDoc from '../../../assets/Documents/CoverageDocuments/CO.pdf';
import CT_CoverageDoc from '../../../assets/Documents/CoverageDocuments/CT.pdf';
import GA_CoverageDoc from '../../../assets/Documents/CoverageDocuments/GA.pdf';
import HI_CoverageDoc from '../../../assets/Documents/CoverageDocuments/HI.pdf';
import ID_CoverageDoc from '../../../assets/Documents/CoverageDocuments/ID.pdf';
import IL_CoverageDoc from '../../../assets/Documents/CoverageDocuments/IL.pdf';
import IN_CoverageDoc from '../../../assets/Documents/CoverageDocuments/IN.pdf';
import IA_CoverageDoc from '../../../assets/Documents/CoverageDocuments/IA.pdf';
import KS_CoverageDoc from '../../../assets/Documents/CoverageDocuments/KS.pdf';
import KY_CoverageDoc from '../../../assets/Documents/CoverageDocuments/KY.pdf';
import LA_CoverageDoc from '../../../assets/Documents/CoverageDocuments/LA.pdf';
import ME_CoverageDoc from '../../../assets/Documents/CoverageDocuments/ME.pdf';
import MD_CoverageDoc from '../../../assets/Documents/CoverageDocuments/MD.pdf';
import MA_CoverageDoc from '../../../assets/Documents/CoverageDocuments/MA.pdf';
import MI_CoverageDoc from '../../../assets/Documents/CoverageDocuments/MI.pdf';
import MS_CoverageDoc from '../../../assets/Documents/CoverageDocuments/MS.pdf';
import MO_CoverageDoc from '../../../assets/Documents/CoverageDocuments/MO.pdf';
import MT_CoverageDoc from '../../../assets/Documents/CoverageDocuments/MT.pdf';
import NE_CoverageDoc from '../../../assets/Documents/CoverageDocuments/NE.pdf';
import NH_CoverageDoc from '../../../assets/Documents/CoverageDocuments/NH.pdf';
import NV_CoverageDoc from '../../../assets/Documents/CoverageDocuments/NV.pdf';
import NY_CoverageDoc from '../../../assets/Documents/CoverageDocuments/NY.pdf';
import ND_CoverageDoc from '../../../assets/Documents/CoverageDocuments/ND.pdf';
import OH_CoverageDoc from '../../../assets/Documents/CoverageDocuments/OH.pdf';
import OK_CoverageDoc from '../../../assets/Documents/CoverageDocuments/OK.pdf';
import OR_CoverageDoc from '../../../assets/Documents/CoverageDocuments/OR.pdf';
import PA_CoverageDoc from '../../../assets/Documents/CoverageDocuments/PA.pdf';
import SD_CoverageDoc from '../../../assets/Documents/CoverageDocuments/SD.pdf';
import TN_CoverageDoc from '../../../assets/Documents/CoverageDocuments/TN.pdf';
import TX_CoverageDoc from '../../../assets/Documents/CoverageDocuments/TX.pdf';
import UT_CoverageDoc from '../../../assets/Documents/CoverageDocuments/UT.pdf';
import VT_CoverageDoc from '../../../assets/Documents/CoverageDocuments/VT.pdf';
import VA_CoverageDoc from '../../../assets/Documents/CoverageDocuments/VA.pdf';
import WA_CoverageDoc from '../../../assets/Documents/CoverageDocuments/WA.pdf';
import WY_CoverageDoc from '../../../assets/Documents/CoverageDocuments/WY.pdf';
import CloseIcon from '../../../assets/images/close.svg';

let pLink = styles.pLink;

class CoverageDocs extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showPopover: false,
            popUp: false,
            pageTitle: 'Coverage Documents | AIG AppleCare+ with Theft and Loss Claims'
        };
        this.open = this.open.bind(this);
        this.close = this.close.bind(this);
    }

    componentWillMount() {
        // FOR GTM ANALYTICS
        dataLayerPush('/vendor/apple/coveragedocs', 'Coverage Documents');
    }

    mapHandler = (stateName) => {
        console.log({ stateName });
        // this.props.history.push("/vendor/apple/coveragedocs/plantype");
        //this.props.history.push({ pathname: `/programcoveragedocs`, state: { stateName } })
        switch (stateName) {
            case 'Alabama':
                window.open(ExNY_CoverageDoc, 'blank');
                break;
            case 'Alaska':
                window.open(AK_CoverageDoc, 'blank');
                break;
            case 'Arizona':
                window.open(AZ_CoverageDoc, 'blank');
                break;
            case 'Arkansas':
                window.open(AR_CoverageDoc, 'blank');
                break;
            case 'California':
                window.open(ExNY_CoverageDoc, 'blank');
                break;
            case 'Colorado':
                window.open(CO_CoverageDoc, 'blank');
                break;
            case 'Connecticut':
                window.open(CT_CoverageDoc, 'blank');
                break;
            case 'District of Columbia':
                window.open(ExNY_CoverageDoc, 'blank');
                break;
            case 'Delaware':
                window.open(ExNY_CoverageDoc, 'blank');
                break;
            case 'Florida':
                window.open(ExNY_CoverageDoc, 'blank');
                break;
            case 'Georgia':
                window.open(GA_CoverageDoc, 'blank');
                break;
            case 'Hawaii':
                window.open(HI_CoverageDoc, 'blank');
                break;
            case 'Idaho':
                window.open(ID_CoverageDoc, 'blank');
                break;
            case 'Illinois':
                window.open(IL_CoverageDoc, 'blank');
                break;
            case 'Indiana':
                window.open(IN_CoverageDoc, 'blank');
                break;
            case 'Iowa':
                window.open(IA_CoverageDoc, 'blank');
                break;
            case 'Kansas':
                window.open(KS_CoverageDoc, 'blank');
                break;
            case 'Kentucky':
                window.open(KY_CoverageDoc, 'blank');
                break;
            case 'Louisiana':
                window.open(LA_CoverageDoc, 'blank');
                break;
            case 'Maine':
                window.open(ME_CoverageDoc, 'blank');
                break;
            case 'Maryland':
                window.open(MD_CoverageDoc, 'blank');
                break;
            case 'Massachusetts':
                window.open(MA_CoverageDoc, 'blank');
                break;
            case 'Michigan':
                window.open(MI_CoverageDoc, 'blank');
                break;
            case 'Minnesota':
                window.open(ExNY_CoverageDoc, 'blank');
                break;
            case 'Mississippi':
                window.open(MS_CoverageDoc, 'blank');
                break;
            case 'Missouri':
                window.open(MO_CoverageDoc, 'blank');
                break;
            case 'Montana':
                window.open(MT_CoverageDoc, 'blank');
                break;
            case 'Nebraska':
                window.open(NE_CoverageDoc, 'blank');
                break;
            case 'Nevada':
                window.open(NV_CoverageDoc, 'blank');
                break;
            case 'New Hampshire':
                window.open(NH_CoverageDoc, 'blank');
                break;
            case 'New Jersey':
                window.open(ExNY_CoverageDoc, 'blank');
                break;
            case 'New Mexico':
                window.open(ExNY_CoverageDoc, 'blank');
                break;
            case 'New York':
                window.open(NY_CoverageDoc, 'blank');
                break;
            case 'North Carolina':
                window.open(ExNY_CoverageDoc, 'blank');
                break;
            case 'North Dakota':
                window.open(ND_CoverageDoc, 'blank');
                break;
            case 'Ohio':
                window.open(OH_CoverageDoc, 'blank');
                break;
            case 'Oklahoma':
                window.open(OK_CoverageDoc, 'blank');
                break;
            case 'Oregon':
                window.open(OR_CoverageDoc, 'blank');
                break;
            case 'Pennsylvania':
                window.open(PA_CoverageDoc, 'blank');
                break;
            case 'Rhode Island':
                window.open(ExNY_CoverageDoc, 'blank');
                break;
            case 'South Carolina':
                window.open(ExNY_CoverageDoc, 'blank');
                break;
            case 'South Dakota':
                window.open(SD_CoverageDoc, 'blank');
                break;
            case 'Tennessee':
                window.open(TN_CoverageDoc, 'blank');
                break;
            case 'Texas':
                window.open(TX_CoverageDoc, 'blank');
                break;
            case 'Utah':
                window.open(UT_CoverageDoc, 'blank');
                break;
            case 'Vermont':
                window.open(VT_CoverageDoc, 'blank');
                break;
            case 'Virginia':
                window.open(VA_CoverageDoc, 'blank');
                break;
            case 'Washington':
                window.open(WA_CoverageDoc, 'blank');
                break;
            case 'West Virginia':
                window.open(ExNY_CoverageDoc, 'blank');
                break;
            case 'Wisconsin':
                window.open(ExNY_CoverageDoc, 'blank');
                break;
            case 'Wyoming':
                window.open(WY_CoverageDoc, 'blank');
                break;
            default:
                console.log('All cases missed', stateName);
        }
    };

    onChangeFunc = (optionSelected, eventName, name) => {
        console.log({ optionSelected, name });
        this.mapHandler(name);
    };
    open = (e) => {
        this.setState({
            popUp: !this.state.popUp
        });
    };

    close = (e) => {
        this.setState({
            popUp: false
        });
    };
    render() {
        const { pageTitle } = this.state;
        const filteredOptions =
            data
            && Object.values(data).map((e) => {
                return { data: e.abbreviation, display: e.name };
            });

        return (
            <DocumentTitle title={pageTitle}>
                <div>
                    <div className={styles.pageHeader}>
                        <Container className={styles.pageHeaderContent}>
                            <h1 class='mb-0'>Want to View Your Coverage Details?</h1>
                            <p>
                                Select the correct state to view your AppleCare+ with Theft and Loss coverage document.
                            </p>
                            <p>
                                (Selecting the correct state is important,{' '}
                                <button
                                    className={classNames('btnLink', pLink)}
                                    aria-modal='true'
                                    role='dialog'
                                    id='learnMore'
                                    color='link'
                                    title='Learn more'
                                    onClick={this.open}
                                >
                                    learn more
                                </button>
                                {this.state.popUp && (
                                    <div className={styles.learnMoreText}>
                                        <div className={styles.popOverLMHead}>
                                            <p>Select the state based on where the device was purchased:</p>
                                            <button
                                                className={styles.closeBtn}
                                                onClick={this.close}
                                            >
                                                <img
                                                    alt='close'
                                                    src={CloseIcon}
                                                />
                                            </button>
                                        </div>
                                        <ul>
                                            <li>
                                                <b>Apple or Best Buy store </b>- state of store
                                            </li>
                                            <li>
                                                <b>Online </b> - state associated with the billing address tied to the
                                                method of payment used to purchase coverage
                                            </li>
                                            <li>
                                                <b>Online purchase picked up at Best Buy store </b>- state of store
                                            </li>
                                        </ul>
                                    </div>
                                )}
                                )
                            </p>
                            <p class='mb-0'>
                                Or{' '}
                                <a
                                    href='https://www.apple.com/legal/sales-support/applecare/applecareplus/us/'
                                    target='blank'
                                >
                                    click here
                                </a>{' '}
                                to view the AppleCare+ portion of your AppleCare+ with Theft and Loss terms and
                                conditions.
                            </p>
                        </Container>
                    </div>
                    <Container className={styles.stateSelection}>
                        <div className='form-group  col-md-3 col-12 p-0'>
                            <label
                                htmlFor='state'
                                class='form-label'
                            >
                                Choose a State
                            </label>
                            <div
                                class='dropdown col p-0'
                                id='reach-skip-nav'
                                tabIndex='0'
                            >
                                <DropDownAutoComplete
                                    id='state'
                                    options={filteredOptions}
                                    classNamePrefix='autoDrop'
                                    isClearable={true}
                                    isSearchable={true}
                                    onChangedValue={this.onChangeFunc}
                                />
                            </div>
                        </div>
                    </Container>
                    <Container
                        className={classNames(styles.usMap, 'mapsvg')}
                        role='presentation'
                        aria-hidden='true'
                    >
                        <USAMap
                            className={styles.path}
                            onClick={this.mapHandler}
                        />
                    </Container>
                    <Container>
                        <p className='discl mt-5'>
                            To purchase Theft and Loss as a stand-alone insurance policy, please see detailed pricing on
                            your{' '}
                            <br
                                className='show-lg-up'
                                aria-hidden='true'
                            />
                            state-specific Insurance Coverage Documents, send an email to{' '}
                            <a href='mailto:contractcreation@aig.com'>contractcreation@aig.com</a> or call{' '}
                            <a
                                href='tel:866-243-6434'
                                className='callLink'
                            >
                                (866) 243-6434.
                            </a>
                        </p>
                    </Container>
                </div>
            </DocumentTitle>
        );
    }
}

export default CoverageDocs;
